import React from "react";
import { Box, Stack, TextField, Typography } from "@mui/material";
import CustomButton from "../../Buttons/Button/CustomButton";

export interface CustomFormCreateInputProps {
  value: string;
  onChange: (value: string) => void;
  onAdd: () => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  addButtonLabel?: string;
}

const CustomFormCreateInput: React.FC<CustomFormCreateInputProps> = ({
  value,
  onChange,
  onAdd,
  disabled,
  label = "カスタムフォーム作成",
  placeholder = "項目名を入力",
  addButtonLabel = "追加",
}) => {
  const trimmed = value.trim();
  const handleAdd = () => {
    if (!trimmed || disabled) return;
    onAdd();
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: "12px !important",
          fontWeight: 700,
          paddingBottom: "4px",
          marginBottom: "1px",
          textAlign: "left",
        }}
      >
        {label}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TextField
            size="small"
            fullWidth
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAdd();
              }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "white",
                borderRadius: "8px",
                height: "36px",
                fontSize: 12,
              },
            }}
          />
        </Box>
        <CustomButton
          label={addButtonLabel}
          buttonCategory="submit"
          onClick={handleAdd}
          disabled={disabled || !trimmed}
        />
      </Stack>
    </>
  );
};

export default CustomFormCreateInput;
